import React, { useRef } from 'react';
import {
  Text,
  Icon,
  TextField,
  ActionButton,
  DetailsList,
  SelectionMode,
  Stack,
  FontWeights,
  getTheme,
  mergeStyleSets,
  useTheme,
} from '@fluentui/react';
import SystemClient from '../../../../system/SystemClient';
import MessageCourier from '../../../../lib/MessageCourier';
import { DefaultButton, Label } from '@fluentui/react';
import PlanillaPartidoForm from '../../PlanillaPartidoForm';
import { useCustomInput } from '../../../../common/custom-hooks/useCustomInput';
import { Partido } from '../../../../system/Partido/Partido';
import { TeamCardForConfeccion } from './ConfeccionPlanillaPartido';
import CustomInputIfc from '../../../../lib/FormValidator/Form/CustomInputIfc';
import { PlanillaPartidoContext } from '../../../../system/PlanillaPartido/PlanillaPartidoSystem';
import { Equipo } from '../../../../system/Equipo/Equipo';
import { Jugador } from '../../../../system/Jugador/Jugador';
import { Categoria } from '../../../../system/Categoria/Categoria';
import { Entrenador } from '../../../../system/Entrenador/Entrenador';
import { PlanillaPartidoJugador } from '../../../../system/PlanillaPartidoJugador/PlanillaPartidoJugador';
import { JugadorSelector } from '../../../Jugador/JugadorSelector';
import { JugadorXEquipo } from '../../../../system/JugadorXEquipo/JugadorXEquipo';
import { EntrenadorSelector } from '../../../Entrenador/EntrenadorSelector';
import { PlanillaPartidoOficialAuxiliar } from '../../../../system/PlanillaPartidoOficialAuxiliar/PlanillaPartidoOficialAuxiliar';
import OficialAuxiliarView from './OficialAuxiliarView';
import { PlanillaPartidoOficial } from '../../../../system/PlanillaPartidoOficial/PlanillaPartidoOficial';
import { EntrenadorCardForConfeccion } from './CardUtils/EntrenadorCardForConfeccion';
import { JugadorCardForConfeccion } from './CardUtils/JugadorCardForConfeccion';
import ErrorListForInput from '../../../../lib/FormValidator/Form/ErrorListForInput';
import MinPlayersPopUp from './MinPlayersPopUp';
import RuleErrorDialog from './RuleErrorDialog';
import { PlanillaPartidoReglaJugadorDisponibleCategoriasInferior } from '../../../../system/PlanillaPartidoReglaJugadorDisponibleCategoriasInferior/PlanillaPartidoReglaJugadorDisponibleCategoriasInferior';
import DialogTemplate from '../../../Common/DialogTemplate';
import { Torneo } from '../../../../system/Torneo/Torneo';
import { useContainerStyle } from '../../../../common/custom-hooks/useStyles';

interface IConfeccionPlanillaPartidoTeam {
  system: SystemClient;
  courier: MessageCourier;
  changeBlockUI: (state: boolean) => void;
  form: PlanillaPartidoForm;
  partido: Partido;
  onBlurCustomInput: (customInput: CustomInputIfc) => void;
  context: PlanillaPartidoContext;
  equipo: Equipo;
  showJugadores: boolean;
  setShowJugadores: (b: boolean) => void;
  showOficiales: boolean;
  setShowOficiales: (b: boolean) => void;
  contextListJugador: Jugador[];
  contextListEntrenador: Entrenador[];
  rules: PlanillaPartidoReglaJugadorDisponibleCategoriasInferior[];
  categorias: Categoria[];
  torneo: Torneo;
}
export const MAX_HANDBALL_PLAYERS_PER_TEAM = 16;
export const MIN_HANDBALL_PLAYERS_PER_TEAM = 5;
const MAX_OFICIALES_AUXILIARES = 3;
const ConfeccionPlanillaPartidoTeam = ({
  system,
  courier,
  changeBlockUI,
  form,
  partido,
  onBlurCustomInput,
  context,
  equipo,
  showJugadores,
  setShowJugadores,
  showOficiales,
  setShowOficiales,
  contextListJugador,
  contextListEntrenador,
  rules,
  categorias,
  torneo,
}: IConfeccionPlanillaPartidoTeam) => {
  const oficialesAuxiliaresInput = useCustomInput(() => form.getOficialesAuxiliaresInput(), [form]);
  const planillaPartidoJugadoresInput = useCustomInput(() => form.getPlanillaPartidoJugadoresInput(), [form]);
  const oficialesInput = useCustomInput(() => form.getOficialesInput(), [form]);

  const [showFormAuxiliar, setShowFormAuxiliar] = React.useState<boolean>(false);
  // const [showMinHandballPlayersPopUp, setShowMinHandballPlayersPopUp] = React.useState<boolean>(false);
  const [showRuleErrorDialog, setShowRuleErrorDialog] = React.useState<boolean>(false);
  const [showErrorDialogDorsal, setShowErrorDialogDorsal] = React.useState<boolean>(false);
  const [hasBeenInformed, setHasBeenInformed] = React.useState<boolean>(false);
  const [recoverFocusTo, setRecoverFocusTo] = React.useState<number>(-1);

  const inputRefs = useRef([]);

  const usaListaBuenaFe = partido.getTorneo()!.getTieneListaBuenaFe();

  // SI AL CARGAR LA PLANILLA HAY MENOS DE 5 JUGADORES CON DORSAL
  // React.useEffect(() => {
  //   if (
  //     form.getListPlanillaPartidoJugadoresByEquipo(equipo.getId()!).filter((ppj) => !!ppj.getDorsal())
  //       .length < MIN_HANDBALL_PLAYERS_PER_TEAM
  //   ) {
  //     setShowMinHandballPlayersPopUp(true);
  //   }
  // }, [
  //   form.getListPlanillaPartidoJugadoresByEquipo(equipo.getId()!).filter((ppj) => !!ppj.getDorsal()).length <
  //     MIN_HANDBALL_PLAYERS_PER_TEAM,
  // ]);

  const changeDorsalByJugador = (jugId: string, nv: string) => {
    const jugador = form.getJugadoresByEquipo(String(equipo.getId())).find((j) => j.getId() == jugId);

    if (
      (jugador && form.validateRulesInAddForTeam(equipo.getId()!, rules, categorias, jugador)) ||
      nv == ''
    ) {
      if (nv === '' || (+nv > 0 && +nv < 100)) {
        const planillaPartidoJugadores = [
          ...planillaPartidoJugadoresInput.getValue(),
        ] as PlanillaPartidoJugador[];
        const jugIdx = planillaPartidoJugadores.findIndex(
          (ppj) => +ppj.getJugid() === +jugId && ppj.isActive()
        );
        planillaPartidoJugadores[jugIdx].setDorsal(+nv);
        planillaPartidoJugadoresInput.setValue(planillaPartidoJugadores);
        planillaPartidoJugadoresInput.onBlur();
        onBlurCustomInput(planillaPartidoJugadoresInput);
      }
    } else {
      setShowRuleErrorDialog(true);
    }
  };

  const isCapitan = (jugId: string) => {
    const planillaPartidoJugadores = [
      ...planillaPartidoJugadoresInput.getValue(),
    ] as PlanillaPartidoJugador[];
    const jugIdx = planillaPartidoJugadores.findIndex((ppj) => +ppj.getJugid() === +jugId && ppj.isActive());
    return planillaPartidoJugadores[jugIdx].isCapitan();
  };

  const setCapitan = (jugId: string) => {
    const planillaPartidoJugadores = [
      ...planillaPartidoJugadoresInput.getValue(),
    ] as PlanillaPartidoJugador[];
    const jugIdx = planillaPartidoJugadores.findIndex((ppj) => +ppj.getJugid() === +jugId && ppj.isActive());
    const isCap = !!planillaPartidoJugadores[jugIdx].isCapitan();
    planillaPartidoJugadores.forEach((ppj) => {
      if (+ppj.getEqid() === +equipo.getId()!) {
        ppj.setIsCapitan(false);
      }
    });
    planillaPartidoJugadores[jugIdx].setIsCapitan(!isCap);
    console.log('planillaPartidoJugadores > ', planillaPartidoJugadores);
    planillaPartidoJugadoresInput.setValue(planillaPartidoJugadores);
    planillaPartidoJugadoresInput.onBlur();
    onBlurCustomInput(planillaPartidoJugadoresInput);
  };

  const addJugadorToTeam = async (jugador: Jugador) => {
    const planillaPartidoJugadores = [
      ...planillaPartidoJugadoresInput.getValue(),
    ] as PlanillaPartidoJugador[];

    planillaPartidoJugadores.push(
      PlanillaPartidoJugador.createFrom('', 0, +equipo.getId()!, +jugador.getId()!, 0, false, jugador, false)
    );

    planillaPartidoJugadoresInput.setValue(planillaPartidoJugadores);
    planillaPartidoJugadoresInput.onBlur();
    onBlurCustomInput(planillaPartidoJugadoresInput);
  };

  const deleteAuxiliar = (item: any) => {
    const oficialesAuxiliares = [...oficialesAuxiliaresInput.getValue()] as PlanillaPartidoOficialAuxiliar[];
    const idx = oficialesAuxiliares.findIndex(
      (oa) =>
        oa.getNombre() === item.ppoa_nombre &&
        oa.getApellido() === item.ppoa_apellido &&
        oa.getDni() === item.ppoa_dni
    );
    if (idx > -1) {
      if (oficialesAuxiliares[idx].getId()) {
        oficialesAuxiliares[idx].setDeleted(true);
      } else {
        oficialesAuxiliares.splice(idx, 1);
      }
      oficialesAuxiliaresInput.setValue(oficialesAuxiliares);
    }
  };

  const onRender = (label: any) => {
    return <span style={{ fontSize: 16 }}>{label}</span>;
  };

  const containerStyle = useContainerStyle();

  const columnsAux = [
    {
      key: 'ppoa_orden',
      name: 'Orden',
      fieldName: 'ppoa_orden',
      minWidth: 50,
      maxWidth: 50,
      onRender: (item: any) => onRender(`${item.ppoa_orden}`),
    },
    {
      key: 'ppoa_nombre',
      name: 'Oficial auxiliar',
      fieldName: 'ppoa_nombre',
      minWidth: 100,
      onRender: (item: any) => onRender(`${item.ppoa_apellido}, ${item.ppoa_nombre}`),
    },
    {
      key: 'ppoa_dni',
      name: 'DNI',
      fieldName: 'ppoa_dni',
      minWidth: 100,
      onRender: (item: any) => onRender(`${item.ppoa_dni}`),
    },
    {
      key: 'ppoa_id',
      name: '',
      fieldName: 'ppoa_id',
      onRender: (item: any) => {
        return (
          <Icon
            iconName="Trash"
            className="clickable"
            onClick={() => deleteAuxiliar(item)}
            style={{ fontSize: 16, color: '#cb0000' }}
          ></Icon>
        );
      },
      minWidth: 100,
    },
  ];

  const addEntrenadorToTeam = (entrenador: Entrenador) => {
    const oficiales = [...oficialesInput.getValue()] as PlanillaPartidoOficial[];
    oficiales.push(
      PlanillaPartidoOficial.createFrom('', 0, +equipo.getId()!, +entrenador.getId()!, entrenador, false)
    );
    oficialesInput.setValue(oficiales);
  };

  const deleteEntrenador = (entrenador: Entrenador) => {
    const oficiales = [...oficialesInput.getValue()] as PlanillaPartidoOficial[];
    const idx = oficiales.findIndex((o) => o.isActive() && +o.getEntid() === +entrenador.getId()!);
    if (idx > -1) {
      if (oficiales[idx].getId()) {
        oficiales[idx].setDeleted(true);
      } else {
        oficiales.splice(idx, 1);
      }
      oficialesInput.setValue(oficiales);
    }
  };

  const deleteJugador = (jugador: Jugador) => {
    const planillaPartidoJugadores = [
      ...planillaPartidoJugadoresInput.getValue(),
    ] as PlanillaPartidoJugador[];

    const idx = planillaPartidoJugadores.findIndex((j) => +j.getJugid() === +jugador.getId()!);

    if (idx > -1) {
      if (planillaPartidoJugadores[idx].getId()) {
        planillaPartidoJugadores[idx].setDeleted(true);
      } else {
        planillaPartidoJugadores.splice(idx, 1);
      }
      planillaPartidoJugadoresInput.setValue(planillaPartidoJugadores);
      planillaPartidoJugadoresInput.onBlur();
      onBlurCustomInput(planillaPartidoJugadoresInput);
    }
  };

  const sameNumberChecker = (i: number) => {
    let isValid = true;

    const jugadores = [
      ...form
        .getPlanillaPartidoJugadoresInput()
        .getValue()
        .filter((ppj: PlanillaPartidoJugador) => ppj.isActive() && ppj.getDorsal()),
    ];

    jugadores.forEach((ppj: PlanillaPartidoJugador, idx1: number) => {
      jugadores.forEach((ppj2: PlanillaPartidoJugador, idx2: number) => {
        const hasRepeated =
          idx1 !== idx2 &&
          ppj2.isActive() &&
          !!ppj2.getDorsal() &&
          +ppj.getEqid() === +ppj2.getEqid() &&
          +ppj.getDorsal() === +ppj2.getDorsal();
        if (hasRepeated) {
          isValid = false;
        }
      });
    });

    if (!isValid) {
      setShowErrorDialogDorsal(true);
    }
  };

  const hasRepeated = (jugId: string, dorsal: number, eqId: string) => {
    const ppjList = [
      ...form
        .getPlanillaPartidoJugadoresInput()
        .getValue()
        .filter((ppj: PlanillaPartidoJugador) => ppj.isActive() && ppj.getDorsal()),
    ];
    return ppjList.some(
      (ppj) => +ppj.getDorsal() === +dorsal && +ppj.getJugid() !== +jugId && +ppj.getEqid() === +eqId
    );
  };

  const theme = useTheme();

  return (
    <>
      {showRuleErrorDialog && (
        <RuleErrorDialog showPopUp={showRuleErrorDialog} setShowPopUp={setShowRuleErrorDialog} />
      )}

      <div className="ms-Grid-col ms-sm12 ">
        <div className="ms-Grid-row ">
          <div className="ms-Grid-col ms-sm12  text-center">
            <TeamCardForConfeccion system={system} equipo={equipo}></TeamCardForConfeccion>
          </div>
        </div>
      </div>
      <div className="ms-Grid-col ms-sm6 ">
        {showJugadores && (
          <div className="ms-motion-slideDownIn">
            <div className="ms-Grid-row ">
              <div className="ms-Grid-col ms-sm12  text-center">
                <div className="ms-Grid-col ms-sm2 text-center mt-2">
                  <Text variant="mediumPlus" style={{ fontWeight: 500 }} block>
                    Dorsal
                  </Text>
                </div>
                <div className="ms-Grid-col ms-sm10 text-center  mt-2">
                  <Text variant="mediumPlus" style={{ fontWeight: 500 }} block>
                    Jugadores
                  </Text>
                </div>

                {form
                  .getJugadoresByEquipo(String(equipo.getId()))
                  .sort((a, b) => Jugador.sortByFullameFn(a, b))
                  .map((jugador, i) => {
                    const dorsal = form.getDorsalBy(String(jugador.getId()));
                    const repetido = hasRepeated(
                      String(jugador.getId()),
                      +form.getDorsalBy(String(jugador.getId())),
                      equipo.getId()!
                    );
                    return (
                      <div key={i} className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 " style={{ paddingLeft: 0, paddingRight: 0 }}>
                          <div className="ms-Grid-col ms-sm2 mt-2">
                            <TextField
                              key={i}
                              // @ts-ignore
                              componentRef={(el) => (inputRefs.current[i] = el)}
                              value={form.getDorsalBy(String(jugador.getId()))}
                              onChange={(_e, nv) => changeDorsalByJugador(String(jugador.getId()), nv!)}
                              styles={{
                                fieldGroup: {
                                  height: 77,
                                  background: repetido ? '#ffdbdb' : 'transparent',
                                },
                                field: {
                                  fontSize: 45,
                                  textAlign: 'center',
                                  color: repetido ? 'black' : theme.palette.black,
                                },
                              }}
                              disabled={
                                !jugador.getActivo() ||
                                jugador.estaSuspendido() ||
                                (form
                                  .getListPlanillaPartidoJugadoresByEquipo(equipo.getId()!)
                                  .filter((ppj) => !!ppj.getDorsal()).length ===
                                  MAX_HANDBALL_PLAYERS_PER_TEAM &&
                                  !!!form.getDorsalBy(String(jugador.getId())))
                              }
                              onBlur={() => {
                                const isValid = sameNumberChecker(i);
                              }}
                              errorMessage={repetido ? 'Dorsal repetido' : ''}
                            />
                          </div>

                          <JugadorCardForConfeccion
                            jugador={jugador}
                            system={system}
                            context={context}
                            deleteJugador={!torneo.getTieneListaBuenaFe() ? deleteJugador : () => {}}
                            disabledApparience={!!!form.getDorsalBy(String(jugador.getId()))}
                            suspendedApparience={jugador.estaSuspendido()}
                            inactiveApparience={!jugador.getActivo()}
                            showCapitanButton={!!dorsal}
                            isCapitan={isCapitan(jugador.getId()!)}
                            setCapitan={() => setCapitan(jugador.getId()!)}
                          ></JugadorCardForConfeccion>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="ms-Grid-col ms-sm6 ">
        {!torneo.getTieneListaBuenaFe() && (
          <div style={containerStyle} className="padding-1">
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm12">
                <Text variant="medium" style={{ fontWeight: 600, fontSize: 16 }}>
                  Jugadores
                </Text>
              </div>
            </div>
            <div className="ms-Grid-row mt-2">
              <div className="ms-Grid-col ms-sm12">
                <Label>Buscar</Label>
                <JugadorSelector
                  clearOnSelect
                  system={system}
                  courier={courier}
                  onSelect={addJugadorToTeam}
                  selected={[]}
                  providedList={form.getListJugadoresByEquipo(equipo.getId()!, contextListJugador)}
                ></JugadorSelector>
              </div>
            </div>
          </div>
        )}
        {showOficiales && (
          <div className="ms-motion-slideDownIn">
            <div style={containerStyle} className="padding-1 mt-2">
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12">
                  <Text variant="medium" style={{ fontWeight: 600, fontSize: 16 }}>
                    Oficial A
                  </Text>
                </div>
              </div>

              {!usaListaBuenaFe && (
                <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-sm12">
                    <Label>Buscar</Label>
                    <EntrenadorSelector
                      clearOnSelect
                      system={system}
                      courier={courier}
                      onSelect={addEntrenadorToTeam}
                      selected={[]}
                      providedList={contextListEntrenador}
                      disabled={
                        oficialesInput
                          .getValue()
                          .filter(
                            (o: PlanillaPartidoOficial) => o.isActive() && +o.getEqid() === +equipo.getId()!
                          ).length === 1
                      }
                    ></EntrenadorSelector>
                  </div>
                </div>
              )}
              {oficialesInput
                .getValue()
                .filter(
                  (o: PlanillaPartidoOficial) => o.isActive() && +o.getEqid() === +equipo.getId()!
                )[0] && (
                <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-sm12">
                    <EntrenadorCardForConfeccion
                      entrenador={oficialesInput
                        .getValue()
                        .filter(
                          (o: PlanillaPartidoOficial) => o.isActive() && +o.getEqid() === +equipo.getId()!
                        )[0]
                        .getEntrenador()}
                      system={system}
                      deleteEntrenador={deleteEntrenador}
                    ></EntrenadorCardForConfeccion>
                  </div>
                </div>
              )}
            </div>
            <div className="padding-1" style={containerStyle}>
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12">
                  <Text variant="medium" style={{ fontWeight: 600, fontSize: 16 }}>
                    Oficiales auxiliares
                  </Text>
                </div>
              </div>
              {!usaListaBuenaFe && (
                <div className="ms-Grid-row  mt-2">
                  <div className="ms-Grid-col ms-sm12">
                    <DefaultButton
                      onClick={() => {
                        setShowFormAuxiliar(true);
                      }}
                      iconProps={{ iconName: 'Add' }}
                      disabled={
                        oficialesAuxiliaresInput
                          .getValue()
                          .filter((oa: PlanillaPartidoOficialAuxiliar) => +oa.getEqid()! === +equipo.getId()!)
                          .length === MAX_OFICIALES_AUXILIARES
                      }
                    >
                      Agregar oficial auxiliar
                    </DefaultButton>
                  </div>
                </div>
              )}
              {showFormAuxiliar && (
                <OficialAuxiliarView
                  equipo={equipo}
                  setShowFormAuxiliar={(b: boolean) => setShowFormAuxiliar(b)}
                  oficialesAuxiliaresInput={oficialesAuxiliaresInput}
                ></OficialAuxiliarView>
              )}
              {form.getOficialesAuxiliaresByEquipoId(equipo.getId()!).length > 0 && (
                <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-sm12">
                    <DetailsList
                      items={form.getOficialesAuxiliaresByEquipoId(equipo.getId()!)}
                      selectionMode={SelectionMode.none}
                      columns={columnsAux}
                      onShouldVirtualize={() => false}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ConfeccionPlanillaPartidoTeam;
